module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-foot",
    domProps: {
      "innerHTML": _vm._s(_vm.copyright)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-55236381!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 96
// module chunks = 1